import moment from "moment";
import { NumericFormat } from "react-number-format";
import CustomerIdCell from "src/utils/customerIdCell";


export const DateColumnHandler = ({data}) => {
    const date=data?.dataItem?.applyTime;
    return (
        <td>
            <div className="gridLink text-light-valueColor">
                {date ? <> {moment.utc(date).local().format("DD/MM/YYYY hh:mm:ss A")}</> : date}
            </div>           
        </td>
    )
}
export const StatusColumnHandler = ({data,badge}) => {
    const status = data?.dataItem?.status
    return (
        <td> <span className={`status-badge ${badge[status?.toLowerCase()] || 'bg-green'}`}>{status}</span></td>

    )
}

export const NumberFormatter = ({ value }) => {
    return<td>
      <NumericFormat 
        value={value} 
        decimalScale={2} 
        thousandSeparator={true} 
        thousandsGroupStyle="lakh" 
        displayType="text" 
      />
    </td>
};

export const TransactionsIdColumnHandler = ({data,copiedId,handleIdCopy}) => {
    const transactionId = data?.dataItem?.transactionId;
    return (<td>
    <CustomerIdCell customerId={transactionId} copied={copiedId} handleCopy={handleIdCopy}/>
    </td>)
}

